module.exports = __webpack_public_path__ + "img/sound.0603267b.svg";